<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="size"
    :height="size"
    viewBox="0 0 16 16"
    class="svg-icon"
  >
    <g
      :fill="color"
      fill-rule="nonzero"
      transform="translate(-260.000000, -201.000000) translate(194.000000, 193.000000)"
    >
      <path
        d="M16 1.333V12c0 .24-.128.46-.336.579l-4.667 2.666-.016.01-.063.03.08-.04c-.037.022-.076.039-.115.052-.023.008-.046.015-.07.02l-.03.006c-.037.007-.076.01-.116.01l.05-.002-.043.002c-.03 0-.052 0-.074-.003l-.025-.003c-.035-.005-.069-.012-.102-.022l-.033-.011c-.022-.008-.042-.017-.063-.027l-.008-.004-5.015-2.507-4.357 2.49c-.444.253-.997-.067-.997-.58V4c0-.24.128-.46.336-.579L5.003.755 5.02.744c.022-.011.043-.021.066-.03l-.084.04c.036-.02.074-.038.113-.051.02-.007.038-.012.058-.017.017-.004.033-.008.05-.01.036-.006.072-.01.11-.01L5.29.669l.028-.001h.014c.027 0 .054.001.08.004l.012.002c.035.005.069.012.102.022l.017.006c.03.01.058.021.085.035l.002.001 5.015 2.507 4.357-2.49c.444-.253.997.067.997.58zM6 2.412v9.177l4 2V4.412l-4-2zm-1.334.07L1.333 4.387v9.13l3.333-1.904V2.482zm10 0l-3.333 1.905v9.13l3.334-1.904v-9.13z"
        transform="translate(66.000000, 8.000000)"
      />
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-map",
  components: {},
})
export class IconMap extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;

  constructor() {
    super();
  }
}
export default IconMap;
</script>
